import { Controller } from "@hotwired/stimulus"
import ModalController from "@/controllers/view/modal_controller"

const LAST_ACCESS_AT_KEY = "sessionPopupLastAccessAt"

export default class extends Controller {
  static targets: string[] = ["popup"]
  static outlets: string[] = ["modal"]
  static values = {
    timeoutMinutes: Number,
    delayMs: Number,
    preview: Boolean
  }

  declare readonly modalOutlet: ModalController
  declare readonly timeoutMinutesValue: number
  declare readonly delayMsValue: number
  declare readonly previewValue: boolean

  connect() {
    if (this.previewValue) {
      this.modalOutlet.open()
      return
    }

    const sessionTimeout = this.timeoutMinutesValue * 60 * 1000
    const now = new Date().getTime()
    const lastAccessAt: number = parseInt(localStorage.getItem(LAST_ACCESS_AT_KEY) || "0", 10)

    localStorage.setItem(LAST_ACCESS_AT_KEY, now.toString())

    if (!lastAccessAt || now - lastAccessAt > sessionTimeout) {
      setTimeout(() => {
        this.modalOutlet.open()
      }, this.delayMsValue)
    }
  }
}
